import cx from 'classnames';
import React, { FC, PropsWithChildren } from 'react';
import { useContactCalendarOAuth } from '@wix/ai-scheduling-assistant-data-store';
import { Box, Heading, Text } from '@wix/design-system';
import { useAuthTokenContext } from '../../../../context/AuthTokenContext';
import { useScreenWidth } from '../../../../hooks/useScreenWidth';
import { useIsChatScrolled } from '../../../../hooks/useScrollableChatElement';
import { useUouLanguage } from '../../../../hooks/useUouLanguage';
import s from './uouChatHeader.scss';
import { ContactManagementMenu } from './UoUChatHeaderPopoverMenu';

export interface UoUChatHeaderProps {
  businessName: string;
  contactName?: string;
}

const DEFAULT_BUSINESS_NAME = 'Orion';

export const UoUChatHeader: FC<PropsWithChildren<UoUChatHeaderProps>> = ({ businessName, contactName }) => {
  const { isScrolled } = useIsChatScrolled();
  const { authToken } = useAuthTokenContext();
  const { isCalendarConnected } = useContactCalendarOAuth(authToken);
  const { isMobile } = useScreenWidth();
  const language = useUouLanguage();

  const businessNameToDisplay = businessName || DEFAULT_BUSINESS_NAME;

  return (
    <Box className={cx(s.headerContainer, { [s.headerContainerScrolled]: isScrolled })}>
      <Box direction={isMobile ? 'vertical' : 'horizontal'} className={s.titleContainer} gap={isMobile ? 0 : 1} verticalAlign="middle">
        <Heading size={isMobile ? 'tiny' : 'medium'} className={s.businessName}>
          {businessNameToDisplay}
        </Heading>
        <Text className={s.subtitle} secondary size={isMobile ? 'small' : 'medium'}>
          {language.ASA_STANDALONE_HEADER_SUB_TITLE()}
        </Text>
      </Box>
      <Box align="right" direction="horizontal" verticalAlign="middle" gap={2}>
        {isCalendarConnected && contactName && <ContactManagementMenu contactName={contactName} />}
      </Box>
    </Box>
  );
};
